import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { toUpper } from "lodash";
import { searchBrandsApi } from "../../api/search.api";

const { Option } = Select;

const BrandAutocomplete = ({
  onChange,
  disabled,
  value,
  singleValue = false,
  style = {},
}) => {
  const [brandList, setBrandList] = useState([]);
  const [currValue, setCurrValue] = useState(value || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => setCurrValue(value), [value]);

  const mode = singleValue ? "" : "multiple";

  return (
    <Select
      mode={mode}
      showSearch
      value={
        singleValue
          ? (currValue?.[0]?.id || currValue?.[0]?.toString() || undefined)
          : currValue?.map((el) => el?.id || el?.toString())
      }
      filterOption={false}
      style={{ width: "100%", ...style }}
      disabled={disabled}
      loading={loading}
      allowClear
      onClear={() => {
        setCurrValue([]);
        if (typeof onChange === "function" && !disabled) {
          onChange([]);
        }
      }}
      onChange={(v, opt) => {
        let newVal;
        if (!v) {
          newVal = [];
        } else if (Array.isArray(v)) {
          newVal = v.map((val) => {
            const existing = (currValue || []).find(
              (el) => (el?.id || el?.toString()) === val
            );
            if (existing) return existing;

            const option = Array.isArray(opt) ? opt.find((o) => o?.value === val) : null;
            if (option?.obj) return option.obj;

            return { id: val };
          });
        } else {
          let obj = (currValue || []).find(
            (el) => (el?.id || el?.toString()) === v
          );
          if (!obj && opt?.obj) {
            obj = opt.obj;
          }
          newVal = obj ? [obj] : [{ id: v }];
        }

        setCurrValue(newVal);
        if (typeof onChange === "function" && !disabled) {
          onChange(newVal);
        }
      }}
      onSearch={async (val) => {
        if (val && val.length > 2) {
          setLoading(true);
          try {
            const res = await searchBrandsApi({
              params: `?name=${encodeURIComponent(val)}&pageNum=1`,
            });
            setLoading(false);
            setBrandList(
              (res.data || []).map((r) => ({
                label: r.name,
                value: r._id,
                obj: { id: r._id, name: r.name },
              }))
            );
          } catch (e) {
            console.error("Error searching brands:", e);
            setLoading(false);
          }
        }
      }}
      placeholder={disabled ? "—" : ""}
    >
      {brandList.map((el, key) => (
        <Option key={key} value={el.value} obj={el.obj}>
          {toUpper(el.label)}
        </Option>
      ))}
    </Select>
  );
};

export default BrandAutocomplete;
